import { Component, OnInit, Input } from '@angular/core';
import { User } from 'src/app/Models/Commonmodule/user';
import { ApiService } from 'src/app/Service/api.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Role } from 'src/app/Models/Commonmodule/role';
import { CookieService } from 'ngx-cookie-service';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})

export class UserComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: User;
  passwordVisible = false;
  password: string;
  isSpinning = false
  dataList: User;
  roleLoading = false
  roles: Role[];
  TeamLeads: Role[];
  ROLE_IDS: number[];


  constructor(private api: ApiService, private message: NzNotificationService , private cookie: CookieService,private modal: NzModalService) { }

  roleId : any =  this.cookie.get('roleId')


  ngOnInit() {
    this.loadRoles();
    this.loadTeamLeads();
    this.loadAllCategories();

    console.log(this.roleId);
    
    
  }

  //// Only number
  omit(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  loadTeamLeads(){
   
    this.api.getAllUsers(0, 0, '', '',  ' AND IS_ACTIVE = 1 ').subscribe(TeamLeads => {
      this.TeamLeads = TeamLeads['data']; 

    }, err => {
 
    });
  }
  loadRoles() {
    this.roleLoading = true;
    this.api.getAllRoles(0, 0, '', '', "").subscribe(roles => {
      this.roles = roles['data'];
      this.roleLoading = false;

    }, err => {

      this.roleLoading = false;
    });
  }

  categoryList = [];

  loadAllCategories() {
    this.api.getAllCategories(0, 0, 'ID', 'desc', ' and IS_ACTIVE=1').subscribe(categoryData => {
      this.categoryList = categoryData['data'];

    }, err => {

    });
  }

  close(): void {
    this.data.RATE_PER_HOUR = null
    this.drawerClose();
  }

  isValidMobile(mobile) {
    const expression = /^[6-9]\d{9}$/;
    return expression.test(String("" + mobile).toLowerCase())
  }

  isValidEmail(email) {
    const expression = /^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/;
    return expression.test(String(email).toLowerCase())
  }
allowNumbersOnly(event: KeyboardEvent): void {
  const charCode = event.which || event.keyCode;

  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
  }
}
isValidEmployeeId(employeeId: string): boolean {
  return /^[0-9]+$/.test(employeeId);
}
    // Number with decimal format
    numberWithDecimal(event: any) {
      const charCode = event.which ? event.which : event.keyCode;
  
      if (
        charCode === 46 && // Decimal point character code
        event.target.value.includes('.')
      ) {
        return false;
      } else if (
        charCode !== 46 && // Decimal point character code
        charCode > 31 &&
        (charCode < 48 || charCode > 57)
      ) {
        return false;
      }
  
      return true;
    }
    isValidRate(rate: any): boolean {
      console.log("RATE_PER_HOUR:", rate); // Debugging purpose
      return rate !== null && rate !== '' && !isNaN(rate) && rate >= 0; // Ensure it's a valid number and non-negative
    }
checkDuplicateEmployeeId(callback: Function): void {

  let filter = " AND EMPLOYEE_ID='" + this.data.EMPLOYEE_ID + "'";

  this.api.getAllUsers(0, 0, "", "", filter).subscribe(res => {

    let duplicate = false;

    if (res['data'] && res['data'].length > 0) {

      // Ignore current record while editing
      duplicate = res['data'].some(user => user.ID != this.data.ID);
    }

    if (duplicate) {

      this.modal.confirm({
        nzTitle: 'Employee ID already exists',
        nzContent: 'Do you want to continue?',
        nzOkText: 'Yes',
        nzCancelText: 'No',
        nzOnOk: () => {
          callback();
        }
      });

    } else {

      callback();

    }

  });

}
   save(addNew: boolean): void {

  if (
    this.isValidMobile(this.data.MOBILE_NUMBER) &&
    this.isValidEmail(this.data.EMAIL_ID) &&
    /^[a-zA-Z\s-, ]*$/.test(this.data.NAME)  &&
  this.data.EMPLOYEE_ID !== null &&
  this.data.EMPLOYEE_ID !== undefined &&
  this.data.EMPLOYEE_ID !== '' &&
    (this.roleId != 10 || this.isValidRate(this.data.RATE_PER_HOUR))
  ) {

    this.checkDuplicateEmployeeId(() => {
      this.saveUser(addNew);
    });

  } else {

    if (!this.isValidMobile(this.data.MOBILE_NUMBER)) {
      this.message.error("Please Enter Valid Mobile Number", "");
    }
    else if (!this.isValidEmail(this.data.EMAIL_ID)) {
      this.message.error("Please Enter Valid Email ID", "");
    }
    else if (!/^[a-zA-Z\s-, ]*$/.test(this.data.NAME)) {
      this.message.error("Please Enter Valid Name", "");
    }
    else if (
    this.data.EMPLOYEE_ID === null ||
    this.data.EMPLOYEE_ID === undefined ||
    this.data.EMPLOYEE_ID === ''
  ) {
    this.message.error("Please Enter Employee ID", "");
  }
    else if (this.roleId == 10 && !this.isValidRate(this.data.RATE_PER_HOUR)) {
      this.message.error("Please Enter Valid Rate Per Hour", "");
    }

  }

}
saveUser(addNew: boolean): void {

  this.isSpinning = true;

  if (this.data.ID) {

    // UPDATE

    this.api.updateUser(this.data).subscribe(successCode => {

      if (successCode['code'] == "200") {

        this.message.success("User Updated Successfully", "");

        if (!addNew) {
          this.drawerClose();
        }

      } else {

        this.message.error("Failed to Update User", "");

      }

      this.isSpinning = false;

    });

  } else {

    // CREATE

    this.api.createUser(this.data).subscribe(successCode => {

      if (successCode['code'] == "200") {

        this.message.success("User Added Successfully", "");

        if (!addNew) {

          this.drawerClose();

        } else {

          this.data = new User();

          this.api.getAllUsers(1, 1, '', 'desc', '').subscribe(data => {

            if (data['code'] == 200) {

              if (data['count'] == 0) {
                this.data.SEQ_NO = 1;
              } else {
                this.data.SEQ_NO = data['data'][0]['SEQ_NO'] + 1;
              }

            }

          });

        }

      } else {

        this.message.error("Failed to Add User", "");

      }

      this.isSpinning = false;

    });

  }

}
  searchEmail(emailId): void {
    var likeQuery = "EMAIL_ID=" + emailId + "";
    this.api.getAllUsers(0, 0, "", "", likeQuery).subscribe(data => {

      this.dataList = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.message.error("Server Not Found", "");
    });
  }
}
